export default __webpack_public_path__ + "static/media/florence.b4c27dd8.png";